import { ComponentDirective } from './../../directives/component.directive';
import { PersonalInfoComponent } from './components/personal-info/personal-info.component';
import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe, DecimalPipe } from '@angular/common';
import { StepperComponent } from './components/stepper/stepper.component';
import { StatusBarComponent } from './components/status-bar/status-bar.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ResidenceInfoComponent } from './components/residence-info/residence-info.component';
import { PreviousResidenceInfoComponent } from './components/previous-residence-info/previous-residence-info.component';
import { EmploymentInfoComponent } from './components/employment-info/employment-info.component';
import { PreviousEmploymentInfoComponent } from './components/previous-employment-info/previous-employment-info.component';
import { BankOffersComponent } from './components/bank-offers/bank-offers.component';
import { ReviewInfoComponent } from './components/review-info/review-info.component';
import { AdditionalInfoComponent } from './components/additional-info/additional-info.component';
import { TextMaskDirective } from '../../directives/text-mask.directive';
import { ReceivingBankOffersComponent } from './components/receiving-bank-offers/receiving-bank-offers.component';
import { NgxUiLoaderConfig, NgxUiLoaderModule } from 'ngx-ui-loader';
import { SafeHtmlPipe } from '../../pipes/safe-html.pipe';
import { ConfirmationPageComponent } from './components/confirmation-page/confirmation-page.component';
import { UnlockComponent } from './components/unlock/unlock.component';
import { AutofocusDirective } from '../../directives/autofocus.directive';
import { PrequalComponent } from './components/prequal/prequal/prequal.component';
import { PrequalResultComponent } from './components/prequal/prequal/prequal-result/prequal-result.component';
import 'bingmaps';
import { AnModalModule } from '@autonation/dt-an-components-lib/an-modal';

// Importing Get Lower Price Library Module
import {  DtAnGetlowerpriceleadformLibModule } from '@autonation/dt-an-getlowerpriceleadform-lib';

import { DtAnPricedetailsLibModule } from '@autonation/dt-an-pricedetails-lib';
import { BaseTooltipModalComponent } from './components/base-tooltip-modal/base-tooltip-modal.component';
import { PriceDetailsModalComponent } from './components/price-details-modal/price-details-modal.component';
import { UsdOnlyDirective } from '../../directives/usd-only.directive';
import { AnTooltipModule } from '@autonation/dt-an-components-lib/an-tooltip';
import { ContactStoreComponent } from './components/contact-store/contact-store.component';
import { PrequalModalComponent } from './components/prequal/prequal/prequal-modal/prequal-modal.component';
import { PrequalResultModalComponent } from './components/prequal/prequal/prequal-modal/prequal-result/prequal-result-modal.component';

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  bgsColor: 'white',
  // bgsOpacity: 0.5,
  // bgsPosition: POSITION.bottomCenter,
  // bgsSize: 60,
  // bgsType: SPINNER.rectangleBounce,
  // fgsColor: 'blue',
  // fgsPosition: POSITION.centerCenter,
  fgsSize: 0,
  // fgsType: SPINNER.chasingDots,
  // tslint:disable-next-line:max-line-length
  logoUrl: '',
  pbColor: 'var(--pink-600)',
  // pbDirection: PB_DIRECTION.leftToRight,
  pbThickness: 2,
  // text: 'Welcome to ngx-ui-loader',
  // textColor: 'var(--white)',
  // textPosition: POSITION.centerCenter,
  overlayColor: 'rgba(255,255,255,.8)'
};

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        DtAnGetlowerpriceleadformLibModule,
        DtAnPricedetailsLibModule,
        AnModalModule,
        AnTooltipModule,
        NgxUiLoaderModule.forRoot(ngxUiLoaderConfig)
        // NgxUiLoaderHttpModule.forRoot({ showForeground: true })
    ],
    declarations: [
        StepperComponent,
        PersonalInfoComponent,
        PreviousResidenceInfoComponent,
        ResidenceInfoComponent,
        ComponentDirective,
        StatusBarComponent,
        EmploymentInfoComponent,
        PreviousEmploymentInfoComponent,
        BankOffersComponent,
        ReceivingBankOffersComponent,
        ReviewInfoComponent,
        AdditionalInfoComponent,
        TextMaskDirective,
        SafeHtmlPipe,
        ConfirmationPageComponent,
        UnlockComponent,
        AutofocusDirective,
        PrequalComponent,
        PrequalResultComponent,
        BaseTooltipModalComponent,
        PriceDetailsModalComponent,
        UsdOnlyDirective,
        ContactStoreComponent,
        PrequalModalComponent,
        PrequalResultModalComponent
    ],
    providers: [
        CurrencyPipe,
        DecimalPipe
    ],
    exports: [
        StepperComponent,
        ResidenceInfoComponent,
        ContactStoreComponent,
        PreviousResidenceInfoComponent,
        PersonalInfoComponent,
        EmploymentInfoComponent,
        PreviousEmploymentInfoComponent,
        ReceivingBankOffersComponent,
        BankOffersComponent,
        AdditionalInfoComponent,
        ReviewInfoComponent,
        ConfirmationPageComponent,
        PrequalComponent,
        PrequalResultComponent,
        PrequalModalComponent,
        PrequalResultModalComponent
    ]
})
export class CreditApplicationModule { }